import React, { useState } from "react"

import './styles.css';
import { sxLabel } from '../../../../../assets/styles/CommonSxProps';
import DefaultTextBold from "../../../../../components/Accessibility/DefaultTextBold";
import DefaultText from "../../../../../components/Accessibility/DefaultText";
import { MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { sxFilterSelect, sxMenuItem } from "./sxProps";
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import { ITipoAtendimento } from "../../../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/TipoAtendimento";
import { FormikProps } from "formik";
import { usePrimeiroAgendamentoContext } from "../../contexts/PrimeiroAgendamentoContext";
import { AgendarAtendimentoFormik } from "../../../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/AgendarAtendimentoFormik";
import ButtonAccessibility from "../../../../../components/Accessibility/ButtonAccessibility";

interface TipoAtendimentoFormProps {
    tipoAtendimento: ITipoAtendimento
    formik: FormikProps<AgendarAtendimentoFormik>
}

export const TipoAtendimentoForm: React.FC<TipoAtendimentoFormProps> = ({ tipoAtendimento, formik }: TipoAtendimentoFormProps) => {
    const { textStyleAccessibility } = useAccessibility()
    const { setTabs } = usePrimeiroAgendamentoContext()

    const handleChange = (event: SelectChangeEvent) => {
        formik.setFieldValue('tipoAtend', event.target.value)
    };

    return (
        <div className='page-container'>
            <div className="flex-col gap-16">
                <DefaultTextBold text="Atendimento" />
                <DefaultText text={tipoAtendimento.titulo} />
            </div>
            <div className="width-100 page-container-box-tipo-atendimento">
                <Typography style={textStyleAccessibility} sx={sxLabel}>Tipo de atendimento</Typography>
                <Select
                    value={formik.values.tipoAtend}
                    onChange={handleChange}
                    fullWidth
                    sx={sxFilterSelect}
                    IconComponent={(props) => <FontAwesomeIcon icon={faChevronDown} {...props} color={'#383838'} />}
                    displayEmpty
                    renderValue={
                        formik.values.tipoAtend !== "" ? () => tipoAtendimento?.items?.find((option) => option.value === formik.values.tipoAtend)?.subtitulo : () => <span className='placeholder'>Selecione</span>
                    }
                >
                    {tipoAtendimento?.items?.map((option) => (
                        <MenuItem key={`filter-${option.value}`} value={option.value} sx={sxMenuItem}>{option.subtitulo}</MenuItem>
                    ))}
                </Select>
            </div>
            <div className="page-container-button">
                <ButtonAccessibility
                    variant="contained"
                    fullWidth
                    disabled={formik.values.tipoAtend === ""}
                    onClick={() => setTabs((prev) => prev + 1)}
                >
                    CONTINUAR
                </ButtonAccessibility>
            </div>
        </div>
    )
}